import { Api } from './api';
export var fetchApi = new Api({
    baseURL: process.env.REACT_APP_API_URL,
    withCredentials: true,
});
export * from './api';
